import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';

const NotFound = () => {
  // 添加useEffect钩子，确保页面返回404状态码
  useEffect(() => {
    // 使用document.title更新页面标题
    document.title = '404 - 页面未找到 | DestinyCrystal命理水晶';
    
    // 创建一个meta标签，让搜索引擎知道这是404页面
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex';
    document.head.appendChild(metaRobots);

    // 清理函数
    return () => {
      if (metaRobots.parentNode) {
        document.head.removeChild(metaRobots);
      }
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>404 - 页面未找到 | DestinyCrystal命理水晶</title>
        <meta name="robots" content="noindex" />
        <meta name="googlebot" content="noindex" />
        {/* 添加HTTP状态码标识，帮助搜索引擎识别 */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "首页",
                "item": "https://destiny-crystal.com/"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "404 - 页面未找到"
              }]
            }
          `}
        </script>
      </Helmet>
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            textAlign: 'center'
          }}
        >
          <Typography variant="h1" color="primary" sx={{ fontSize: { xs: '6rem', md: '10rem' } }}>
            404
          </Typography>
          <Typography variant="h4" sx={{ mb: 4 }}>
            页面未找到
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: '500px' }}>
            您访问的页面不存在或已被移除。请检查URL是否正确，或返回首页。
          </Typography>
          <Button 
            variant="contained" 
            size="large" 
            component={RouterLink} 
            to="/"
          >
            返回首页
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default NotFound;